import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { solicitarReset, actualizarContrasenia } from "../api/usuarios";
import { getRestauranteActual } from "../api/public";
import fondo from "../assets/fondo-restaurante.jpg";

const RecuperarContrasenia = () => {
  const [step, setStep] = useState(1);
  const [correo, setCorreo] = useState("");
  const [token, setToken] = useState("");
  const [nueva, setNueva] = useState("");
  const [repetir, setRepetir] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [logo, setLogo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const cargarLogo = async () => {
      try {
        const restaurante = await getRestauranteActual();
        console.log('Restaurante obtenido en RecuperarContrasenia:', restaurante);
        if (restaurante?.logo) {
          const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
          const logoUrl = `${API_URL}${restaurante.logo}?t=${Date.now()}`;
          console.log('Logo URL en RecuperarContrasenia:', logoUrl);
          setLogo(logoUrl);
        } else {
          console.log('No se encontró logo en el restaurante');
        }
      } catch (error) {
        console.error('Error cargando logo en RecuperarContrasenia:', error);
      }
    };

    cargarLogo();
  }, []);

  const handleSolicitar = async (e) => {
    e.preventDefault();
    setError("");
    setMensaje("");
    
    try {
      const res = await solicitarReset(correo);
      setMensaje(res.message);
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.message || "Error al solicitar recuperación");
    }
  };

  const handleActualizar = async (e) => {
    e.preventDefault();
    setError("");
    setMensaje("");

    try {
      const res = await actualizarContrasenia({
        correo,
        token,
        nuevaContrasenia: nueva,
        repetirContrasenia: repetir,
      });
      setMensaje(res.message);
      setStep(3);
    } catch (err) {
      setError(err.response?.data?.message || "Error al actualizar contraseña");
    }
  };

  // Redirige al login cuando step=3
  useEffect(() => {
    if (step === 3) {
      const timer = setTimeout(() => {
        navigate("/login");
      }, 2500);
      return () => clearTimeout(timer);
    }
  }, [step, navigate]);

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${fondo})` }}
    >
      <div className="bg-amber-900/50 p-8 rounded-3xl shadow-2xl w-96 max-w-full backdrop-blur-md">
        {/* Logo del restaurante */}
        <div className="flex justify-center mb-6">
          {logo && <img src={logo} alt="Logo Restaurante" className="h-40 w-auto" />}
        </div>

        {step === 1 && (
          <>
            <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
              Recuperar Contraseña
            </h2>
            <form onSubmit={handleSolicitar} className="space-y-4">
              <input
                type="email"
                placeholder="Correo electrónico"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                required
              />
              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition font-semibold"
              >
                Enviar código
              </button>
            </form>
            <p
              className="text-sm text-center text-blue-500 mt-4 cursor-pointer hover:underline"
              onClick={() => navigate("/login")}
            >
              Volver a iniciar sesión
            </p>
          </>
        )}

        {step === 2 && (
          <>
            <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
              Restablecer Contraseña
            </h2>
            <form onSubmit={handleActualizar} className="space-y-4">
              <input
                type="text"
                placeholder="Clave temporal"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Nueva contraseña"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                value={nueva}
                onChange={(e) => setNueva(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Repetir contraseña"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition"
                value={repetir}
                onChange={(e) => setRepetir(e.target.value)}
                required
              />
              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition font-semibold"
              >
                Actualizar
              </button>
            </form>
          </>
        )}

        {step === 3 && (
          <h2 className="text-2xl font-bold text-center text-green-600">
            {mensaje || "Contraseña actualizada ✅"}
          </h2>
        )}

        {mensaje && step !== 3 && (
          <p className="text-blue-600 text-sm mt-4 text-center bg-blue-50 p-3 rounded-lg">
            {mensaje}
          </p>
        )}
        {error && (
          <p className="text-red-500 text-sm mt-4 text-center bg-red-50 p-3 rounded-lg">
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default RecuperarContrasenia;
